<svg:line
    class="grid-ver"
    *ngFor="let tick of ticks"
    [attr.x1]="scale(tick)"
    [attr.x2]="scale(tick)"
    [attr.y1]="0"
    [attr.y2]="dimensions.boundedHeight"
></svg:line>
